import { GET_WSPOSITIONS, GET_WSPOSITIONS_SUCCESS, GET_WSPOSITIONS_ERROR} from './actionTypes';

export const getWsPositions = (user) => {
    return {
        type: GET_WSPOSITIONS,
        payload: { user }
    }
}

export const getWsPositionsSuccess = (ws_positions, message) => {
    return {
        type: GET_WSPOSITIONS_SUCCESS,
        payload: {ws_positions, message}
    }
}

export const getWsPositionsError = (message) => {
    return {
        type: GET_WSPOSITIONS_ERROR,
        payload: message
    }
}
